module.exports = __webpack_public_path__ + "img/create-user.3624ee9c.svg";